export default __webpack_public_path__ + "static/media/main-complex-layout.00415a14.jpg";